require('./aggregatorGoToEntityCredentialsPSD2.scss')

// @ vendors
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
const { withRouter } = require('react-router-dom');

// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
import AggregatorAddEntityLayout from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityLayout/aggregatorAddEntityLayout';
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
import OKModal from 'commonsComponents/OKModal';
import { OKButton } from 'components/commons/OKButton/OKButton';

// @actions
import { requestUrl, initStorePSD2 } from 'actions/aggregator/aggregatorAddEntityPSD2';

// @utilities
import Storage from 'utilities/storage';
import UrlHelper from 'utilities/urlHelper';
import getBreadCrumbSettings from 'utilities/aggregator/getRenewTokenBreadCrumbSettings';
import getBanksFromAggregatorData from 'utilities/aggregator/getBanksFromAggregatorData';
import findBankByCode from 'utilities/aggregator/findBankByCode';

import { SELECTED_BANK } from 'constants/aggregator/localStorageKeys';

// @constants
const {
    recordPath,
    recordLink,
    PROC_AGGREGATOR_ENTITY_SECOND_STEP,
    PROC_ADD_ENTITY,
    PROC_GO_SECOND_STEP,
    PROC_AGGREGATOR
} = require('utilities/tagging');

class AggregatorGoToEntityCredentialsPSD2 extends React.PureComponent {

    constructor(props) {
        super(props);
        const { bankName, bankCode, bankLogo, userBankId } = this.getSelectedDataBank();
        this.state = { bankName, bankCode, bankLogo, userBankId }
    }

    componentDidMount() {
        const { requestUrl } = this.props;
        const { bankCode, userBankId } = this.state
        requestUrl(bankCode, userBankId);
        recordPath(PROC_AGGREGATOR_ENTITY_SECOND_STEP,null,PROC_ADD_ENTITY, PROC_GO_SECOND_STEP)
    }

    componentWillUnmount() {
        const { initStorePSD2 } = this.props;
        initStorePSD2();
    }

    getSelectedDataBank = () => {
        const { immAggregatorData, match: { params } } = this.props;
        const { bankCode } = params;

        const banks = getBanksFromAggregatorData(immAggregatorData)
        const selectedBank = findBankByCode(banks, bankCode)

        return selectedBank ? {
            bankName: selectedBank.name,
            bankCode: selectedBank.code,
            bankLogo: selectedBank.imageUrl,
            userBankId: selectedBank.userBankId,
        } : {}
    }

    handleGoToEntityCredentials = () => {
        const { bankCode, bankName, bankLogo } = this.state;
        const { redirectionUrl } = this.props
        const urlQueryParamsChunk = redirectionUrl ? redirectionUrl.split("?")[1] : '';
        const queryParams = UrlHelper.getQueryParams(urlQueryParamsChunk) || {};

        Storage.localStorage.set(SELECTED_BANK, {
            bankName,
            bankLogo,
            bankCode,
            state: queryParams.state,
            codeChallenge: queryParams.code_challenge,
        })

        recordLink(PROC_AGGREGATOR, PROC_GO_SECOND_STEP)
        UrlHelper.redirectToExternalURL(redirectionUrl)
    }

    handleModalButtonClick = () => {
        this.props.history.push(`/myprofile/global#pg-other-banks`)
    }

    render() {
        const { bankName, bankLogo } = this.state;
        const { isFetchingUrl, hasError } = this.props;

        return (
            <React.Fragment>
                <AggregatorAddEntityLayout
                    title={formatText('aggregatorAddEntity-renewSessionLayoutTitle')}
                    breadCrumb={getBreadCrumbSettings()}
                >
                    <OKSectionBox
                        className="aggregator-renew-token__go-to-credentials col-md-8"
                        title={formatText('aggregatorPSD2-goToBankTitle', [bankName])}
                        titleSeparator
                    >
                        <div className="aggregator-add-entity-psd2__go-to-credentials__information-wrapper">
                            <div className="aggregator-add-entity-psd2__go-to-credentials__text">
                                <FormattedText value="aggregatorPSD2-goToBankInformation" />
                            </div>
                            <div className="aggregator-add-entity-psd2__go-to-credentials__text">
                                <FormattedText value="aggregatorPSD2-goToBankButtonIndication" injectedStrings={[bankName]} />
                            </div>
                        </div>
                        <div className="aggregator-add-entity-psd2__go-to-credentials__logo-bank-wrapper">
                            <img className="aggregator-add-entity-psd2__go-to-credentials__logo-bank" src={bankLogo} />
                        </div>
                        <div className="aggregator-psd2-credentials__buttons-wrapper">
                            <OKButton onClick={this.handleGoToEntityCredentials} loading={isFetchingUrl}>
                                {formatText('aggregatorPSD2-goToBankTextButton', [bankName])}
                            </OKButton>
                        </div>
                    </OKSectionBox>
                </AggregatorAddEntityLayout>
                <OKModal
                    isOpen={hasError}
                    title={formatText('aggregatorPSD2-redirectionUrlErrorTitle')}
                    content={formatText('aggregatorPSD2-redirectionUrlErrorMessage')}
                    footerType="action"
                    primaryButtonText={formatText('aggregatorPSD2-redirectionUrlErrorButton')}
                    onPrimaryButtonClick={() => this.handleModalButtonClick()}
                    customCloseButton={<div />}
                />
            </React.Fragment>
        );
    }
}

AggregatorGoToEntityCredentialsPSD2.defaultProps = {
    redirectionUrl: '',
    hasError: false,
    isFetchingUrl: true,
}

AggregatorGoToEntityCredentialsPSD2.propTypes = {
    beta: PropTypes.bool,
    hasError: PropTypes.bool,
    initStorePSD2: PropTypes.func,
    history: PropTypes.object.isRequired,
    immAggregatorData: PropTypes.object.isRequired,
    isFetchingUrl: PropTypes.bool,
    redirectionUrl: PropTypes.string,
    requestUrl: PropTypes.func,
    match: PropTypes.object.isRequired,
}

export default connect(state => ({
    immAggregatorData: state.aggregatorData,
    isFetchingUrl: state.aggregatorAddEntityPSD2.get('isFetchingUrl'),
    redirectionUrl: state.aggregatorAddEntityPSD2.get('redirectionUrl'),
    hasError: state.aggregatorAddEntityPSD2.get('error'),
}), {
    requestUrl,
    initStorePSD2,
})(withRouter(AggregatorGoToEntityCredentialsPSD2));
